import * as React from "react";
const SvgFiRrCameraSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-camera-slash_svg__a)">
      <path
        fill="#062147"
        d="m23.707 22.293-1.536-1.536a5 5 0 0 0 .83-2.757v-8c0-2.757-2.244-5-5-5h-.018L16.15 2.31A3 3 0 0 0 13.67 1h-3.34c-.993 0-1.92.489-2.479 1.31L6.178 4.765 1.708.293A.999.999 0 1 0 .292 1.707l22 22a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414M21 10v8c0 .45-.102.892-.293 1.293l-3.903-3.903Q17 14.714 17 14a5.006 5.006 0 0 0-6.39-4.804L8.414 7H18c1.654 0 3 1.346 3 3M10.33 3h3.34c.331 0 .64.163.826.437L15.562 5H8.438l1.066-1.563A1 1 0 0 1 10.33 3M17 22a1 1 0 0 1-1 1H6c-2.757 0-5-2.243-5-5v-8c0-.881.231-1.745.67-2.502A1 1 0 1 1 3.4 8.502c-.262.45-.4.97-.4 1.498v8c0 1.654 1.346 3 3 3h10a1 1 0 0 1 1 1m-5-3c-2.757 0-5-2.243-5-5a1 1 0 1 1 2 0c0 1.654 1.346 3 3 3a1 1 0 1 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-camera-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCameraSlash;
